/*
 * StatusChip — DAO-FOUND-03 Figma tokens
 *
 * Extracted from Figma file fQIlHAfVEaKAhUv2Gki56o:
 *   Frame 5462:51393 (list non-member) — status chip column
 *   Frame 5462:53185 (V3 executed chip)
 *
 * States:
 *   not_approved → bg-bg-tertiary + border border-stroke-light + text-text-secondary
 *   not_executed → bg-bg-tertiary/60 + text-text-primary (no border)
 *   executed     → bg-accent/20 + text-accent (no border)
 *
 * Layout (all states): inline-flex, rounded-xs, px-2 py-1, text-sm font-semibold
 */

// TOKENS
// colors.notApproved: bg-bg-tertiary + border-stroke-light + text-text-secondary
// colors.notExecuted: bg-bg-tertiary/60 + text-text-primary
// colors.executed:    bg-accent/20 + text-accent
// spacing: px-2 py-1
// typography: text-sm font-semibold

import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

export type StatusChipState = "not_approved" | "not_executed" | "executed";

// Per Figma 5462:51393 / 5462:51264, per-state radius differs:
//   not_approved → rounded-full (--full,9999)
//   not_executed → rounded-full (--full,9999)
//   executed     → rounded-md   (--md,12)
const STATE_CLASSES: Record<StatusChipState, string> = {
  not_approved:
    "bg-bg-tertiary border border-stroke-light text-text-secondary rounded-full",
  not_executed: "bg-bg-tertiary/60 text-text-primary rounded-full",
  executed: "bg-accent/20 text-accent rounded-md",
};

interface StatusChipProps {
  state: StatusChipState;
}

export const StatusChip: React.FC<StatusChipProps> = ({ state }) => {
  const t = useTranslations("dao");
  return (
    <span
      data-state={state}
      className={cn(
        "inline-flex h-6 items-center justify-center px-2 text-xs font-medium",
        STATE_CLASSES[state],
      )}
    >
      {t(`proposals.status.${state}`)}
    </span>
  );
};
